import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import {
  getUserPreferencesConfirmedStoreLocale,
  getUserPreferencesLocaleConfirmed,
} from 'selectors/user/cookie'
import { getIsClientReady } from 'selectors/shared/client'

const mapStateToProps = createStructuredSelector({
  isClientReady: getIsClientReady,
  userPreferencesLocaleConfirmed: getUserPreferencesLocaleConfirmed,
  userPreferencesStoreLocale: getUserPreferencesConfirmedStoreLocale,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  isClientReady: boolean
  userPreferencesLocaleConfirmed: boolean
  userPreferencesStoreLocale: string
}
export default connect(mapStateToProps, mapDispatchToProps)
